import React, {useState} from 'react'
import {Tooltip} from "reactstrap";

const TagRequestUpdate = (props) => {
    const {orderId, index, tag, itemRequest} = props
    const [tooltipOpen, setTooltip] = useState(false)

    const _setTooltipOpen = () => {
        setTooltip(!tooltipOpen)
    }

    return (
        <span key={index} className={`badge badge-pill ${tag}`} id={"Tooltip-Tag-" + orderId}>
            {tag === 'waiting-update-design' ? 'request-design' : tag === 'waiting-update-address' ? 'request-address' : tag === 'force-updated-design' ? 'force-updated' : tag}
            {itemRequest && <Tooltip
                     isOpen={tooltipOpen}
                     target={"Tooltip-Tag-" + orderId}
                     toggle={_setTooltipOpen}
                 >
                     {itemRequest}
                 </Tooltip>}
        </span>
    )
}

export default TagRequestUpdate